import { store, useAppSelector } from "store";
import { sandboxActionInvoked } from "store/features";
import { Icon, MenuItem } from "@itwin/itwinui-react";
import { SvgHeart } from "@itwin/itwinui-icons-react";

export const LikeMenuItem = ({ close }: { close: () => void }) => {
  const metadata = useAppSelector((state) => state.activeSandbox.metadata);

  const onClick = () => {
    if (metadata)
      store.dispatch(sandboxActionInvoked({
        type: "like",
        args: {
          userId: metadata.userId,
          sandboxId: metadata.id
        }
      }));

    close();
  }

  return (
    <MenuItem
      icon={metadata?.isLiked ? <Icon fill="negative"><SvgHeart /></Icon> : <SvgHeart />}
      onClick={onClick}
      data-testid={metadata?.isLiked ? "atp-unlike-sandbox": "atp-like-sandbox"}
    >
      {metadata?.isLiked ? "Unlike Sandbox" : "Like Sandbox"}
    </MenuItem>
  )
}
